export default [
  {
    title: 'Komlabs',
    customicon: `<svg height="268.16" viewBox="0 0 305.54 268.16" width="305.54" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="komlabs-icon-a" x1="186.74" x2="234.57" y1="74.53" y2="74.53">
          <stop offset="0" stop-color="#ff66e9" />
          <stop offset="1" stop-color="#d03c9c" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="komlabs-icon-b" x1="0" x2="267.6" y1="172.83" y2="172.83">
          <stop offset="0" stop-color="#ff66e9" />
          <stop offset=".24" stop-color="#fd64e6" />
          <stop offset=".4" stop-color="#f75fdd" />
          <stop offset=".54" stop-color="#ee57ce" />
          <stop offset=".67" stop-color="#e14bb8" />
          <stop offset=".78" stop-color="#d03c9d" />
          <stop offset=".79" stop-color="#d03c9c" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="komlabs-icon-c" x1="110.53" x2="250.27" y1="180.78" y2="180.78">
          <stop offset="0" stop-color="#ff66e9" />
          <stop offset="1" stop-color="#d03c9c" />
        </linearGradient>
      </defs>
      <g>
        <circle cx="91.96" cy="23.91" fill="#ff66e9" r="23.91" />
        <circle cx="210.65" cy="74.53" fill="url(#komlabs-icon-a)" r="23.91" />
        <path d="M136.59 162.38c-1.79-56.61-9.71-84.11-41-84.87-22.98-.55-37.7 12.51-42.94 58.75-6.51 57.06-5.2 88.1-34.49 81.17-9.26-2.19-19.57 5.53-18 15.22 3.15 19.56 38.63 17.65 52.58 6.49 18.51-14.96 20.54-40.91 28.57-101.43 1.27-10.06 2.11-30.77 10.99-31.78 17.41-2.03 16.74 31.61 16.91 56.97.59 79.12 10.48 104.65 40.66 105.24 0 0 11.7.91 20.37-6.68-25.19-8.01-30.92-13.17-33.64-99.07Z" fill="url(#komlabs-icon-b)" />
        <path d="M305.54 214.85c0-6.32-4.98-13.28-19.95-10.77-6.37 1.07-24.53 1.49-35.69-36.21-6.85-23.33-16.06-45.14-39.64-43.19-11.8.97-25.83-.04-37.53 64.5-2.29 12.65-3.76 19.03-6.26 29.59-1.58 7.14-.79 13.73 6.77 17.09 6.72 2.99 16.11.35 18.92-9.09 3.42-11.49 5.52-24.4 7.45-36.23 1.61-10.06 3.13-19.44 4.99-25.7 1.94-6.51 3.07-11.02 8.56-11.18 5.07 0 7.9 7.13 9.7 14.98 14.15 61.82 48.44 63.65 65.85 61.28 8.45-1.1 16.84-6.6 16.84-15.06Z" fill="url(#komlabs-icon-c)" />
      </g>
    </svg>`,
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Settings',
        komicon: 'k-setting-2',
        tagVariant: 'light-warning',
        resource: 'Komlabs - Form',
        action: 'manage',
        children: [
          {
            title: 'Form Pendaftaran',
            route: 'form-pendaftaran-komlabs',
            resource: 'Komlabs - Form',
            action: 'manage',
          },
          {
            title: 'Kategori',
            route: 'kategori-komlabs',
            resource: 'Komlabs - Form',
            action: 'manage',
          },
        ],
      },
      {
        title: 'Creator Management',
        komicon: 'k-user-octagon',
        tagVariant: 'light-warning',
        resource: 'Komlabs - Creator Management',
        action: 'manage',
        children: [
          {
            title: 'Creator Data',
            route: 'creator-data-komlabs',
            resource: 'Komlabs - Creator Management',
            action: 'manage',
          },
          {
            title: 'Creator Distribution',
            route: 'creator-distribution-komlabs',
            resource: 'Komlabs - Creator Management',
            action: 'manage',
          },
          {
            title: 'Upgrade Status',
            route: 'upgrade-status-komlabs',
            resource: 'Komlabs - Creator Management',
            action: 'manage',
          },
        ],
      },
      {
        title: 'Campaign Management',
        customicon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 20px!important; height: 20px!important;">
          <path d="M12.5833 22.334H8.58325C3.15325 22.334 0.833252 20.014 0.833252 14.584V8.58398C0.833252 3.15398 3.15325 0.833984 8.58325 0.833984H14.5833C20.0133 0.833984 22.3333 3.15398 22.3333 8.58398V12.584C22.3333 12.994 21.9933 13.334 21.5833 13.334C21.1733 13.334 20.8333 12.994 20.8333 12.584V8.58398C20.8333 3.97398 19.1933 2.33398 14.5833 2.33398H8.58325C3.97325 2.33398 2.33325 3.97398 2.33325 8.58398V14.584C2.33325 19.194 3.97325 20.834 8.58325 20.834H12.5833C12.9933 20.834 13.3333 21.174 13.3333 21.584C13.3333 21.994 12.9933 22.334 12.5833 22.334Z" fill="#333333"/>
          <path d="M5.13795 12.324C4.97795 12.324 4.81796 12.274 4.67796 12.164C4.34796 11.914 4.28798 11.444 4.53798 11.114L6.91795 8.02399C7.20795 7.65399 7.61797 7.414 8.08797 7.354C8.55797 7.294 9.01795 7.424 9.38795 7.714L11.218 9.154C11.288 9.214 11.358 9.20399 11.408 9.20399C11.448 9.20399 11.518 9.184 11.578 9.104L13.888 6.12399C14.138 5.79399 14.608 5.734 14.938 5.994C15.268 6.244 15.328 6.714 15.068 7.044L12.758 10.024C12.468 10.394 12.058 10.634 11.588 10.684C11.128 10.744 10.658 10.614 10.298 10.324L8.46797 8.884C8.39797 8.824 8.31797 8.82399 8.27797 8.83399C8.23797 8.83399 8.16796 8.854 8.10796 8.934L5.72798 12.024C5.58798 12.224 5.36795 12.324 5.13795 12.324Z" fill="#333333"/>
          <path d="M15.5068 18.0041C15.1568 18.0041 14.7068 17.8941 14.1768 17.5741L13.9268 17.4241C13.8568 17.3841 13.6468 17.3841 13.5768 17.4241L13.3268 17.5741C12.1768 18.2641 11.4468 17.9741 11.1268 17.7341C10.7968 17.4941 10.2868 16.8941 10.5868 15.5741L10.6368 15.3641C10.6568 15.2841 10.5968 15.0941 10.5468 15.0341L10.1968 14.6841C9.6068 14.0841 9.37677 13.3841 9.57677 12.7541C9.77677 12.1341 10.3668 11.6941 11.1968 11.5541L11.5768 11.4941C11.6468 11.4741 11.7868 11.3741 11.8268 11.3041L12.1068 10.7341C12.4968 9.94413 13.0968 9.49414 13.7568 9.49414C14.4168 9.49414 15.0168 9.94413 15.4068 10.7341L15.6868 11.2941C15.7268 11.3641 15.8668 11.4641 15.9368 11.4841L16.3168 11.5441C17.1468 11.6841 17.7368 12.1241 17.9368 12.7441C18.1368 13.3641 17.9168 14.0641 17.3168 14.6741L16.9668 15.0241C16.9168 15.0841 16.8568 15.2741 16.8768 15.3541L16.9268 15.5641C17.2268 16.8841 16.7168 17.4841 16.3868 17.7241C16.2068 17.8641 15.9168 18.0041 15.5068 18.0041ZM13.7368 11.0041C13.7268 11.0141 13.5868 11.1141 13.4468 11.4041L13.1668 11.9741C12.9268 12.4641 12.3568 12.8841 11.8268 12.9741L11.4468 13.0341C11.1268 13.0841 11.0168 13.1941 11.0068 13.2141C11.0068 13.2341 11.0368 13.3941 11.2668 13.6241L11.6168 13.9741C12.0268 14.3941 12.2368 15.1141 12.1068 15.6841L12.0568 15.8941C11.9668 16.2841 12.0068 16.4541 12.0268 16.5141C12.0568 16.4941 12.2268 16.4741 12.5568 16.2741L12.8068 16.1241C13.3568 15.7941 14.1468 15.7941 14.6968 16.1241L14.9468 16.2741C15.3568 16.5241 15.5268 16.4941 15.5368 16.4941C15.4968 16.4941 15.5468 16.2941 15.4568 15.8941L15.4068 15.6841C15.2768 15.1041 15.4868 14.3941 15.8968 13.9741L16.2468 13.6241C16.4768 13.3941 16.5068 13.2341 16.5068 13.2041C16.4968 13.1841 16.3868 13.0841 16.0668 13.0241L15.6868 12.9641C15.1468 12.8741 14.5868 12.4541 14.3468 11.9641L14.0668 11.4041C13.9068 11.1041 13.7668 11.0141 13.7368 11.0041Z" fill="#333333"/>
        </svg>`,
        tagVariant: 'light-warning',
        resource: 'Komlabs - Campaign Management',
        action: 'manage',
        children: [
          {
            title: 'Campaign List',
            route: 'campaign-list-komlabs',
            resource: 'Komlabs - Campaign Management',
            action: 'manage',
          },
        ],
      },
    ],
  },
]
